import {
    apiRequest,
    polaKerjaPegawaiList,
    polaKerjaPegawaiActive,
    polaKerjaPegawaiInactive
} from "../../../../../services/adapters/kepegawaian/polaKerjaPegawaiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", polaKerjaPegawaiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", polaKerjaPegawaiInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", polaKerjaPegawaiActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository